module.exports = __webpack_public_path__ + "static/media/x.e94d129b.svg";